module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/website-badge-nocolor-73559b0ac68eba0b4b54504f84b91ab5.svg";